export default __webpack_public_path__ + "images/00.5812913.png";